import React, { lazy } from 'react';
import SkeletonGrid from '../../../skeleton_loaders/common/SkeletonGrid.jsx';
import withSuspense from '../../../helpers/withSuspense.jsx';
import { useTaskOptions } from '../hooks/useTaskOptions.js';
const HEIGHT = 'calc(100vh - 56px - 30px - 145px)';
const skeletonProps = {
  className: 'task-view',
  skeletonHeight: HEIGHT
}
const TaskDatagrid = withSuspense(lazy(() => import('./TaskDatagrid.jsx')), <SkeletonGrid {...skeletonProps} />);

function TaskServerSideDatagrid({ projectId, groupGridItems, reloadClick, presetId, permissions, baseQueryKey, advancedFeatures, programmeTasks }) {
  const {sorted_columns, task_status_options} = useTaskOptions({projectId});
  const ready = Boolean(sorted_columns && task_status_options);

  if (!ready) return <SkeletonGrid {...skeletonProps} />;

  return (
    <TaskDatagrid
      project_id={projectId}
      height={HEIGHT}
      presetId={presetId}
      containerStyle={{ height: HEIGHT, paddingBottom: 0 }}
      permissions={permissions}
      gridProps={{
        gridOptions: {
          getRowId: (p) => {
            const d = p.data;
            if (d?.group) {
              const key = d.work_package_id ?? d.work_package?.id ?? '__unassigned__';
              return `wp:${String(key)}`;
            }
            return `task:${d.id}`;
          },
          rowModelType: 'serverSide',
          // serverSideStoreType: 'partial',
          autoGroupColumnDef: { headerName: I18n.t('work_package') },
        }
      }}
      groupGridItems={groupGridItems}
      reloadClick={reloadClick}
      baseQueryKey={baseQueryKey}
      advancedFeatures={advancedFeatures}
      programmeTasks={programmeTasks}
    />
  );
}

export default TaskServerSideDatagrid;
